export const MANAGEMENT = "Management";
export const SDTD = "SDTD";
export const UNIT = "Unit team";
export const PARTNER = "Pravartanam Partners";
export const GUEST = "Invited Members";

export const UNIT_ROLES = ["Executive Director", "SPOC", "Group Lead", "CoDE Member", "DDO", "Desk Officer"];

const ROLE_COLORS = {
  Director: "hsl(240 6% 30%)",
  "Executive Director": "hsl(330 65% 48%)",
  SPOC: "hsl(222 85% 56%)",
  "Group Lead": "hsl(268 60% 58%)",
  "CoDE Member": "hsl(145 63% 38%)",
  DDO: "hsl(36 92% 44%)",
  "Desk Officer": "hsl(186 70% 40%)",
  Manager: "hsl(18 80% 46%)",
  "Data Scientist": "hsl(18 70% 56%)",
  "Implementation Expert": "hsl(28 75% 52%)",
  "Domain Expert": "hsl(8 65% 50%)",
  "Invited Member": "hsl(205 20% 52%)",
};

export const roleColor = (role) => ROLE_COLORS[role] || "hsl(var(--muted-foreground))";

export const STATUS = {
  active: ["Signed in", "hsl(var(--healthy))"],
  awaited: ["Details awaited", "hsl(var(--watch))"],
  invited: ["Invited", "hsl(var(--watch))"],
  none: ["Not on the portal", "hsl(var(--muted-foreground))"],
  off: ["Access off", "hsl(var(--destructive))"],
};

export const slug = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-");

/** The fields the server keeps for one person, ready to send back. */
export const toBody = (p) => ({
  card_id: p.card_id || null,
  account_id: p.account_id || null,
  name: p.name || "",
  email: p.email || "",
  team: p.team,
  team_role: p.team_role,
  home: p.home || null,
  units: p.units || [],
  designation: p.designation || "",
  department: p.department || "",
  contact_number: p.contact_number || "",
  whatsapp_number: p.whatsapp_number || "",
  landline: p.landline || "",
  sail_id: p.sail_id || "",
  organisation: p.organisation || "",
});

/** One count per role, each person once — a Group Lead over five units is still one person. */
export const roleTotals = (units = []) => {
  const seen = {};
  units.forEach((t) =>
    t.roles.forEach((r) => {
      seen[r.role] = seen[r.role] || new Set();
      r.people.forEach((p) => seen[r.role].add(p.key));
    }),
  );
  return UNIT_ROLES.map((role) => ({ role, count: seen[role]?.size || 0 }));
};
